__turbopack_context__.v({
  "aboutCopy": "marketing-home-module__q7Au8W__aboutCopy",
  "aboutGrid": "marketing-home-module__q7Au8W__aboutGrid",
  "aboutInner": "marketing-home-module__q7Au8W__aboutInner",
  "aboutPillars": "marketing-home-module__q7Au8W__aboutPillars",
  "aboutSection": "marketing-home-module__q7Au8W__aboutSection",
  "activeNavItem": "marketing-home-module__q7Au8W__activeNavItem",
  "anchorTarget": "marketing-home-module__q7Au8W__anchorTarget",
  "badge": "marketing-home-module__q7Au8W__badge",
  "benefits": "marketing-home-module__q7Au8W__benefits",
  "benefitsBuiltFor": "marketing-home-module__q7Au8W__benefitsBuiltFor",
  "benefitsBuiltForLabel": "marketing-home-module__q7Au8W__benefitsBuiltForLabel",
  "benefitsCard": "marketing-home-module__q7Au8W__benefitsCard",
  "benefitsCardNumber": "marketing-home-module__q7Au8W__benefitsCardNumber",
  "benefitsChip": "marketing-home-module__q7Au8W__benefitsChip",
  "benefitsChips": "marketing-home-module__q7Au8W__benefitsChips",
  "benefitsEyebrow": "marketing-home-module__q7Au8W__benefitsEyebrow",
  "benefitsGrid": "marketing-home-module__q7Au8W__benefitsGrid",
  "benefitsInner": "marketing-home-module__q7Au8W__benefitsInner",
  "benefitsSection": "marketing-home-module__q7Au8W__benefitsSection",
  "brand": "marketing-home-module__q7Au8W__brand",
  "browserBar": "marketing-home-module__q7Au8W__browserBar",
  "builder": "marketing-home-module__q7Au8W__builder",
  "checked": "marketing-home-module__q7Au8W__checked",
  "completion": "marketing-home-module__q7Au8W__completion",
  "copyright": "marketing-home-module__q7Au8W__copyright",
  "ctas": "marketing-home-module__q7Au8W__ctas",
  "customProjectCard": "marketing-home-module__q7Au8W__customProjectCard",
  "customProjectCta": "marketing-home-module__q7Au8W__customProjectCta",
  "customProjectGrid": "marketing-home-module__q7Au8W__customProjectGrid",
  "customProjectHeading": "marketing-home-module__q7Au8W__customProjectHeading",
  "customProjectInner": "marketing-home-module__q7Au8W__customProjectInner",
  "customProjectSection": "marketing-home-module__q7Au8W__customProjectSection",
  "dashboardCard": "marketing-home-module__q7Au8W__dashboardCard",
  "dashboardCardHead": "marketing-home-module__q7Au8W__dashboardCardHead",
  "dashboardChecklist": "marketing-home-module__q7Au8W__dashboardChecklist",
  "dashboardCopy": "marketing-home-module__q7Au8W__dashboardCopy",
  "dashboardCtaBand": "marketing-home-module__q7Au8W__dashboardCtaBand",
  "dashboardEyebrow": "marketing-home-module__q7Au8W__dashboardEyebrow",
  "dashboardGrid": "marketing-home-module__q7Au8W__dashboardGrid",
  "dashboardInner": "marketing-home-module__q7Au8W__dashboardInner",
  "dashboardMockup": "marketing-home-module__q7Au8W__dashboardMockup",
  "dashboardMockupBar": "marketing-home-module__q7Au8W__dashboardMockupBar",
  "dashboardMockupBody": "marketing-home-module__q7Au8W__dashboardMockupBody",
  "dashboardMockupHead": "marketing-home-module__q7Au8W__dashboardMockupHead",
  "dashboardPeriodActive": "marketing-home-module__q7Au8W__dashboardPeriodActive",
  "dashboardPeriods": "marketing-home-module__q7Au8W__dashboardPeriods",
  "dashboardPlan": "marketing-home-module__q7Au8W__dashboardPlan",
  "dashboardProgress": "marketing-home-module__q7Au8W__dashboardProgress",
  "dashboardSection": "marketing-home-module__q7Au8W__dashboardSection",
  "dashboardStatsGrid": "marketing-home-module__q7Au8W__dashboardStatsGrid",
  "dashboardUsageBadge": "marketing-home-module__q7Au8W__dashboardUsageBadge",
  "demoButton": "marketing-home-module__q7Au8W__demoButton",
  "demoContact": "marketing-home-module__q7Au8W__demoContact",
  "demoCopy": "marketing-home-module__q7Au8W__demoCopy",
  "demoError": "marketing-home-module__q7Au8W__demoError",
  "demoEyebrow": "marketing-home-module__q7Au8W__demoEyebrow",
  "demoField": "marketing-home-module__q7Au8W__demoField",
  "demoForm": "marketing-home-module__q7Au8W__demoForm",
  "demoInner": "marketing-home-module__q7Au8W__demoInner",
  "demoSection": "marketing-home-module__q7Au8W__demoSection",
  "demoSubmit": "marketing-home-module__q7Au8W__demoSubmit",
  "demoSuccess": "marketing-home-module__q7Au8W__demoSuccess",
  "description": "marketing-home-module__q7Au8W__description",
  "downloadButton": "marketing-home-module__q7Au8W__downloadButton",
  "featureCard": "marketing-home-module__q7Au8W__featureCard",
  "featureGrid": "marketing-home-module__q7Au8W__featureGrid",
  "featureIcon": "marketing-home-module__q7Au8W__featureIcon",
  "featureMeta": "marketing-home-module__q7Au8W__featureMeta",
  "featureNumber": "marketing-home-module__q7Au8W__featureNumber",
  "featuresEyebrow": "marketing-home-module__q7Au8W__featuresEyebrow",
  "featuresInner": "marketing-home-module__q7Au8W__featuresInner",
  "featuresSection": "marketing-home-module__q7Au8W__featuresSection",
  "fieldHeading": "marketing-home-module__q7Au8W__fieldHeading",
  "footer": "marketing-home-module__q7Au8W__footer",
  "footerBrand": "marketing-home-module__q7Au8W__footerBrand",
  "footerContact": "marketing-home-module__q7Au8W__footerContact",
  "footerContactIcon": "marketing-home-module__q7Au8W__footerContactIcon",
  "footerContactIcons": "marketing-home-module__q7Au8W__footerContactIcons",
  "footerGroup": "marketing-home-module__q7Au8W__footerGroup",
  "footerInner": "marketing-home-module__q7Au8W__footerInner",
  "header": "marketing-home-module__q7Au8W__header",
  "hero": "marketing-home-module__q7Au8W__hero",
  "heroCopy": "marketing-home-module__q7Au8W__heroCopy",
  "heroInner": "marketing-home-module__q7Au8W__heroInner",
  "hosting": "marketing-home-module__q7Au8W__hosting",
  "hostingFlag": "marketing-home-module__q7Au8W__hostingFlag",
  "jobField": "marketing-home-module__q7Au8W__jobField",
  "jobSeekerHeading": "marketing-home-module__q7Au8W__jobSeekerHeading",
  "jobSeekerInner": "marketing-home-module__q7Au8W__jobSeekerInner",
  "jobSeekerSection": "marketing-home-module__q7Au8W__jobSeekerSection",
  "jobSeekerSteps": "marketing-home-module__q7Au8W__jobSeekerSteps",
  "localeSwitch": "marketing-home-module__q7Au8W__localeSwitch",
  "logo": "marketing-home-module__q7Au8W__logo",
  "mockup": "marketing-home-module__q7Au8W__mockup",
  "mockupFooter": "marketing-home-module__q7Au8W__mockupFooter",
  "nav": "marketing-home-module__q7Au8W__nav",
  "navActions": "marketing-home-module__q7Au8W__navActions",
  "navLinks": "marketing-home-module__q7Au8W__navLinks",
  "page": "marketing-home-module__q7Au8W__page",
  "previewIcon": "marketing-home-module__q7Au8W__previewIcon",
  "primaryCta": "marketing-home-module__q7Au8W__primaryCta",
  "resumePreviewEntry": "marketing-home-module__q7Au8W__resumePreviewEntry",
  "resumePreviewMeta": "marketing-home-module__q7Au8W__resumePreviewMeta",
  "resumePreviewSection": "marketing-home-module__q7Au8W__resumePreviewSection",
  "secondaryCta": "marketing-home-module__q7Au8W__secondaryCta",
  "sidebar": "marketing-home-module__q7Au8W__sidebar",
  "sidebarLabel": "marketing-home-module__q7Au8W__sidebarLabel",
  "signInPreview": "marketing-home-module__q7Au8W__signInPreview",
  "signInPreviewImage": "marketing-home-module__q7Au8W__signInPreviewImage",
  "suggestion": "marketing-home-module__q7Au8W__suggestion",
  "suggestions": "marketing-home-module__q7Au8W__suggestions",
  "summaryCard": "marketing-home-module__q7Au8W__summaryCard",
  "summaryCards": "marketing-home-module__q7Au8W__summaryCards",
  "whiteLabelCopy": "marketing-home-module__q7Au8W__whiteLabelCopy",
  "whiteLabelCta": "marketing-home-module__q7Au8W__whiteLabelCta",
  "whiteLabelEyebrow": "marketing-home-module__q7Au8W__whiteLabelEyebrow",
  "whiteLabelGrid": "marketing-home-module__q7Au8W__whiteLabelGrid",
  "whiteLabelInner": "marketing-home-module__q7Au8W__whiteLabelInner",
  "whiteLabelSection": "marketing-home-module__q7Au8W__whiteLabelSection",
  "workspace": "marketing-home-module__q7Au8W__workspace",
});
